import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import CheckIndicator from '../checkindicator/CheckIndicator'
import MainButton from '../common/util/input/MainButton'
import { sleep } from '../helpers/FormatLinks'
import { getBoostAction } from '../helpers/WaxApi'
import { PopupLoadingIndicator } from '../loadingindicator/PopupLoadingIndicator'
import ErrorMessage from './ErrorMessage'
import Popup from './Popup'
import { useSharedState } from '../waxplorer/Waxplorer'

function BulkCancelPopup(props) {
    const assets = props['assets']

    const { t } = useTranslation('common')

    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const callBack = props['callBack']
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState()
    const closeCallBack = props['closeCallBack']
    const [errors, setErrors] = useState({})
    const [transferred, setTransferred] = useState([])
    const [transactions, setTransactions] = useState({})

    const addError = (assetId, e) => {
        errors[assetId] = e
        setErrors(errors)
    }

    const addTransaction = (assetId, tx) => {
        transactions[assetId] = tx
        setTransactions(transactions)
    }

    const maxActions = 10

    const [currentDisplayAction, setCurrentDisplayAction] = useState(0)

    const cancelSales = async () => {
        setIsLoading(true)

        let currentAction = 0

        while (currentAction < Object.keys(assets).length / maxActions) {
            const start = currentAction * maxActions
            const end = start + maxActions
            const actions = [getBoostAction(activeUser)]
            const ownerPlaceIds = []
            const simpleAssetsIds = []

            let sellError = null

            Object.keys(assets)
                .sort((a, b) => parseFloat(a.offer) - parseFloat(b.offer))
                .slice(start, end)
                .map((assetId) => {
                    const asset = assets[assetId]

                    const { market, isAuction, orderId, author } = asset

                    switch (market) {
                        case 'atomicmarket':
                            actions.push({
                                account: market,
                                name: isAuction ? 'cancelauct' : 'cancelsale',
                                authorization: [
                                    {
                                        actor: userName,
                                        permission: activeUser.requestPermission
                                            ? activeUser.requestPermission
                                            : 'active',
                                    },
                                ],
                                data: isAuction
                                    ? {
                                          auction_id: orderId,
                                      }
                                    : {
                                          sale_id: orderId,
                                      },
                            })
                            break
                        case 'waxarena3dk1':
                            actions.push({
                                account: 'waxarena3dk1',
                                name: 'claim',
                                authorization: [
                                    {
                                        actor: userName,
                                        permission: activeUser.requestPermission
                                            ? activeUser.requestPermission
                                            : 'active',
                                    },
                                ],
                                data: {
                                    asset_id: assetId,
                                    winner: userName,
                                },
                            })
                            break
                        case 'alcornftswap':
                            actions.push({
                                account: market,
                                name: 'cancelsell',
                                authorization: [
                                    {
                                        actor: userName,
                                        permission: activeUser.requestPermission
                                            ? activeUser.requestPermission
                                            : 'active',
                                    },
                                ],
                                data: {
                                    maker: userName,
                                    order_id: orderId,
                                },
                            })
                            break
                        case 'waxinventory':
                            actions.push({
                                account: market,
                                name: 'cancel',
                                authorization: [
                                    {
                                        actor: userName,
                                        permission: activeUser.requestPermission
                                            ? activeUser.requestPermission
                                            : 'active',
                                    },
                                ],
                                data: {
                                    owner: userName,
                                    assetids: [assetId],
                                },
                            })
                            simpleAssetsIds.push(assetId)
                            break
                        case 'simpleowner':
                            actions.push({
                                account: market,
                                name: 'cancel',
                                authorization: [
                                    {
                                        actor: userName,
                                        permission: activeUser.requestPermission
                                            ? activeUser.requestPermission
                                            : 'active',
                                    },
                                ],
                                data: {
                                    owner: userName,
                                    assetids: [assetId],
                                },
                            })
                            break
                        case 'waxplorercom':
                            actions.push({
                                account: market,
                                name: 'cancelsale',
                                authorization: [
                                    {
                                        actor: userName,
                                        permission: activeUser.requestPermission
                                            ? activeUser.requestPermission
                                            : 'active',
                                    },
                                ],
                                data: {
                                    sale_id: orderId,
                                },
                            })
                            simpleAssetsIds.push(assetId)
                            break
                        case 'market.place':
                            actions.push({
                                account: 'market.place',
                                name: 'unlist',
                                authorization: [
                                    {
                                        actor: userName,
                                        permission: activeUser.requestPermission
                                            ? activeUser.requestPermission
                                            : 'active',
                                    },
                                ],
                                data: {
                                    account: userName,
                                    listingid: orderId,
                                },
                            })
                            simpleAssetsIds.push(assetId)
                            ownerPlaceIds.push(assetId)
                            break
                    }
                })

            if (ownerPlaceIds.length > 0) {
                actions.push({
                    account: 'market.place',
                    name: 'withdraw',
                    authorization: [
                        {
                            actor: userName,
                            permission: activeUser.requestPermission
                                ? activeUser.requestPermission
                                : 'active',
                        },
                    ],
                    data: {
                        user: userName,
                        assets: ownerPlaceIds.map((id) => {
                            return {
                                contract: 'simpleassets',
                                id: id,
                                quantity: '0.00000000 WAX',
                            }
                        }),
                    },
                })
            }

            if (simpleAssetsIds.length > 0) {
                actions.push({
                    account: 'simpleassets',
                    name: 'claim',
                    authorization: [
                        {
                            actor: userName,
                            permission: activeUser.requestPermission
                                ? activeUser.requestPermission
                                : 'active',
                        },
                    ],
                    data: {
                        claimer: userName,
                        assetids: simpleAssetsIds,
                    },
                })
            }

            try {
                const result = await activeUser.session.transact(
                    {
                        actions: actions,
                    },
                    {
                        expireSeconds: 300,
                        blocksBehind: 0,
                    },
                )
                Object.keys(assets)
                    .sort((a, b) => parseInt(a.value) - parseInt(b.value))
                    .slice(start, end)
                    .map((assetId) =>
                        addTransaction(
                            assetId,
                            result['response']['transaction_id'],
                        ),
                    )
            } catch (e) {
                Object.keys(assets)
                    .sort((a, b) => parseInt(a.value) - parseInt(b.value))
                    .slice(start, end)
                    .map((assetId) => addError(assetId, e.message))
                console.error(e)
                setError(e.message)
                sellError = e
            } finally {
                currentAction += 1
                setCurrentDisplayAction(currentAction)
                if (!error && !sellError) {
                    Object.keys(assets)
                        .sort((a, b) => parseInt(a.value) - parseInt(b.value))
                        .slice(start, end)
                        .map((assetId) => transferred.push(assets[assetId]))
                    setTransferred(transferred)
                }

                if (currentAction < Object.keys(assets).length / maxActions) {
                    sleep(1000)
                }
            }
        }

        setIsLoading(false)
        callBack({
            transferred: transferred,
            errors: errors,
            transactionIds: transactions,
        })
        closeCallBack()
    }

    let transferInfo = t('popups.yes')

    const transferField = (
        <MainButton className="w-[80px] max-w-32" onClick={cancelSales}>
            {transferInfo}
        </MainButton>
    )

    const cancel = () => {
        callBack({
            transferred: true,
            errors: errors,
            transactionIds: transactions,
        })
        closeCallBack()
    }

    return (
        <Popup title={t('asset.cancel')} cancel={cancel}>
            <div className="p-2">
                {Object.keys(transferred).length > 0 ? <CheckIndicator /> : ''}
                {Object.keys(transferred).length === 0 ? (
                    <div className="mx-auto mb-4 text-lg font-bold text-center">
                        {t('popups.are_you_sure_you_want_to_cancel_sales', {
                            number: Object.keys(assets).length,
                        })}
                    </div>
                ) : (
                    ''
                )}
                {error ? <ErrorMessage error={error} /> : ''}
                {Object.keys(transferred).length === 0 ? (
                    <div className="relative flex justify-center gap-2">
                        {transferField}
                        <MainButton onClick={cancel}>
                            {t('popups.no')}
                        </MainButton>
                    </div>
                ) : (
                    ''
                )}
                {isLoading ? (
                    <PopupLoadingIndicator
                        text={t('popups.signing_multiple_transactions', {
                            x: currentDisplayAction,
                            y: Math.ceil(
                                Object.keys(assets).length / maxActions,
                            ),
                        })}
                        isLoading={isLoading}
                    />
                ) : (
                    ''
                )}
            </div>
        </Popup>
    )
}

export default BulkCancelPopup
